import React, { Component, PureComponent } from "react"
import moment from 'moment';
import momentz from 'moment-timezone';
import store from "./store/index";
import 'rc-time-picker/assets/index.css';
import TimePicker from 'rc-time-picker';
import date from "../node_modules/date-and-time"
import { RadioGroup, RadioButton } from 'react-radio-buttons';
import Row from 'react-bootstrap/Form'
import NumericInput from 'react-numeric-input';
import './index.css';
import { updateBackStakeSetting, updateCommissionSetting, updateLatestOddsSettings, updateLayStakeSetting } from "./actions/index";

const spacer = {
  height: '5px'
}

const marginRight = {
  marginRight: '5px'
}

const inlineBlock = {
  display: 'inline-block',
  width: '50%',
  color: 'white',
}



const timerSize = {
  width: '100px'
}
const timerSize1 = {
  width: '100px',
  fontSize: '12px',
  color: '#666',
  paddingLeft: '5px'
}


class TimeSetterLatestOdds extends Component {

  constructor(props) {
    super(props);
    this.state = {
      tickUntilActualStart: store.getState().latestOddsSettings.tickUntilActualStart,
      noOfSeconds: store.getState().latestOddsSettings.noOfSeconds,
      commision: store.getState().latestOddsSettings.commision,
      backStake: store.getState().latestOddsSettings.backStake,
      layStake: store.getState().latestOddsSettings.layStake,
    }

    store.subscribe(this.storeChangeHandler);

  }

  radioButtonChangeHandler = event => {
    //console.log("radioButtonChangeHandler: " + event.target.value)
    let value = event.target.value;
    const payload = {}
    payload.id = "tickUntilActualStart"
    payload.value = value
    store.dispatch(updateLatestOddsSettings(payload));
    this.setState(payload)
  }

  noOfSecondsChangedHandler = event => {
    const noOfSeconds = event.target.value;
    //console.log("noOfSecondsChangedHandler: " + event.target.value)
    if (noOfSeconds >= 0) {
      const payload = {}
      payload.id = "noOfSeconds"
      payload.value = noOfSeconds
      store.dispatch(updateLatestOddsSettings(payload));
      this.setState(payload)
    }
  }

  handleCommisionChange = event => {
    const commision = event.target.value;
    if (commision >= 0) {
      const payload = {}
      payload.id = "commision"
      payload.value = commision
      store.dispatch(updateCommissionSetting(payload));
      this.setState(payload)
    }
  }

  handleBackStakeChange = backStake => {
    if (backStake >= 0) {
      const payload = {}
      payload.id = "backStake"
      payload.value = backStake
      store.dispatch(updateBackStakeSetting(payload));
      this.setState(payload)
    }
  }


  handleLayStakeChange = layStake => {
    if (layStake >= 0) {
      const payload = {}
      payload.id = "layStake"
      payload.value = layStake
      store.dispatch(updateLayStakeSetting(payload));
      this.setState(payload)
    }
  }

  storeChangeHandler = () => {
    const state = {
      tickUntilActualStart: store.getState().latestOddsSettings.tickUntilActualStart,
      noOfSeconds: store.getState().latestOddsSettings.noOfSeconds,
      commision: store.getState().latestOddsSettings.commision,
      backStake: store.getState().latestOddsSettings.backStake,
      layStake: store.getState().latestOddsSettings.layStake
      
    }

    if (this.state.tickUntilActualStart !== state.tickUntilActualStart || this.state.noOfSeconds !== state.noOfSeconds
      || this.state.commision !== state.commision 
      || this.state.backStake !== state.backStake
      || this.state.layStake !== state.layStake) {
      //console.log("storeChangeHandler: " + JSON.stringify(state))
      this.setState(state)
    }
  }

   getStep = (value)  =>{
    if (value < 5) {
      return 0.1;
    } else if (value < 20) {
      return 1;
    } else {
      return 5;
    }
  }

  render() {

    //log(`render: radio: ${this.state.tickUntilActualStart}, noOfSeconds: ${this.state.noOfSeconds}`)

    return (
      <div as={Row} className="divMargin1">

        <div as={Row} className="textColor1" style={{ marginBottom: '10px' }}>
          Commission Setting
        </div>
        <form>
          <div as={Row} className="textColor1" style={{ marginBottom: '10px' }}>
            Commission
            <div style={{ float: "right", marginRight: "110px" }}>
              <input
                id="commission"
                type="number"
                style={{ width: "80px" }}
                value={this.state.commision}
                onChange={this.handleCommisionChange.bind(this)}
              />
            </div>

          </div>
          <div as={Row} className="textColor1" style={{ marginBottom: '10px' }}>
            Back Stake
            <div style={{ float: "right", marginRight: "115px" }}>
            <NumericInput min={0} 
              onChange={this.handleBackStakeChange} 
              step={this.getStep(this.state.backStake)} 
              precision={2} 
              style={{ width: "80px" }}
              value={this.state.backStake} />
            </div>

          </div>
          <div as={Row} className="textColor1" style={{ marginBottom: '10px' }}>
            Lay Stake
            <div style={{ float: "right", marginRight: "115px" }}>
            <NumericInput min={0} 
              onChange={this.handleLayStakeChange} 
              step={this.getStep(this.state.layStake)} 
              precision={2} 
              style={{ width: "80px" }}
              value={this.state.layStake} />
            </div>

          </div>
          <hr style={{ marginLeft: "0px" }} />
          <div as={Row} className="textColor1" style={{ marginBottom: '10px' }}>
            Latest Odds Options
          </div>
          <div style={inlineBlock}>
            <input
              type="radio"
              name="latestOddConfigRadio"
              value="yes"
              checked={this.state.tickUntilActualStart === "yes"}
              onChange={this.radioButtonChangeHandler}
              style={marginRight} />
            Update till actual start</div>

          <div style={inlineBlock}>
            <div style={timerSize}>
              <Row />
            </div>
          </div>
          <div style={spacer}></div>
          <div style={inlineBlock}>
            <input
              type="radio"
              name="latestOddConfigRadio"
              value="no"
              checked={this.state.tickUntilActualStart === "no"}
              onChange={this.radioButtonChangeHandler}
              style={marginRight} />Seconds before start</div>
          <div style={inlineBlock}>
            <input
              id="noOfSettings"
              type="number"
              style={timerSize1}
              disabled={this.state.tickUntilActualStart === "yes"}
              onChange={this.noOfSecondsChangedHandler}
              value={this.state.noOfSeconds}
              defaultValue={parseInt(store.getState().latestOddsSettings.noOfSeconds)} /></div>
        </form>
      </div>
    )
  }
}
export default TimeSetterLatestOdds
